module.exports = __webpack_public_path__ + "images/4348287b15ebf339721bfabb0fa7d15b-teacher1.jpg";